/** Bundle-time QA features. A label or API hostname never enables them. */
export function isQaBuild(): boolean {
  return (typeof __DEV__ !== 'undefined' && __DEV__) ||
    process.env.EXPO_PUBLIC_QA_BUILD === '1' ||
    process.env.EXPO_PUBLIC_VISUAL_FIXTURES === '1' ||
    process.env.EXPO_PUBLIC_PERF_BENCH === '1'
}
